import React from 'react';

interface FormCardProps {
  /** Заголовок секции — большая строка вверху. */
  title: string;
  /** Опциональный подзаголовок мелким серым шрифтом. */
  description?: string;
  /** Опциональный кастомный action в правом верхнем углу карточки
   *  (например, кнопка «Назад» или меню). */
  headerAction?: React.ReactNode;
  /** Дополнительные классы на корневой div (если хочется ограничить
   *  ширину или растянуть на полный экран — управляется снаружи). */
  className?: string;
  children?: React.ReactNode;
}

/**
 * Унифицированная обёртка для форм/секций в стиле раздела «Настройки».
 *
 * Использование:
 *   <FormCard title="Личные данные" description="Эти поля видят коллеги">
 *     <form ...>
 *       <div className="grid grid-cols-2 gap-4">...</div>
 *       <div className="pt-4 flex gap-2">
 *         <Button type="submit">Сохранить</Button>
 *       </div>
 *     </form>
 *   </FormCard>
 */
const FormCard: React.FC<FormCardProps> = ({
  title,
  description,
  headerAction,
  className = '',
  children,
}) => (
  <div
    className={`bg-white rounded-xl shadow-sm overflow-hidden ${className}`}
  >
    <div className="px-6 py-5 border-b border-gray-100 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h2 className="text-lg font-semibold text-[#2d2c2c]">{title}</h2>
        {description ? (
          <p className="text-sm text-gray-500 mt-0.5">{description}</p>
        ) : null}
      </div>
      {headerAction ? <div className="shrink-0">{headerAction}</div> : null}
    </div>
    <div className="px-6 py-6">{children}</div>
  </div>
);

export default FormCard;
